import { useMutation } from "@tanstack/react-query";

import { postContactUsApi } from "@/api/end-points/contactUs";

export const usePostContactUs = (useQueryOptions) => {
  const { onSuccess = () => {}, onError = () => {} } = useQueryOptions || {};
  return useMutation(postContactUsApi, {
    onSuccess: (res) => {
      onSuccess({
        status: res.status,
        message: res.message || "",
      });
    },
    onError: (error) => {
      onError({
        status: error.response.status,
        data: error.response.data,
        message: error.message,
      });
    },
  });
};
